import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Form,
} from "reactstrap";
import "./index.css";
import { useTab } from "@mui/base";
import { Field, Formik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import SvgImage from "../../Icons/Icons";
import DatePicker from "react-datepicker";
import {
  deleteCustomRequest,
  getCustomRequest,
  updateCustomRequest,
} from "../../../services/Store/Actions/fastagAction";
import { colors } from "@material-ui/core";
import { numberToInr, storeDataToAsyncStorage } from "../../../services/Utils/functions";
import {
  getCardRequest,
  updateCardRequest,
} from "../../../services/Store/Actions/cardWalletAction";
import ManageDriverAddBalance from "../../Modals/ManageDriverAddBalance";
import AllImagePopup from "../AllImage";
import { signedUrlWithKey } from "../../../services/Store/Actions/TripsAction";
import { getSignedUrlApiAction } from "../../../services/Store/Actions/appActions";
import { advancedVehicleListAction } from "../../../services/Store/Actions/fleetActions";
import { getDriverList } from "../../../services/Store/Actions/driverslistActions";
import { set } from "date-fns";
import { useNavigate } from "react-router-dom";

function RequestsV2(props) {
  const { toggle, modal, setModal, regNo, title, fleetId } = props;
  const [requestType, setrequestType] = useState(0);
  const { customRequest, customReqCount } = useSelector(
    (state) => state.fastag
  );
  console.log("customRequestcustomRequest", customRequest, customReqCount);
  const dispatch = useDispatch();
  const [type, setType] = useState("ALL");
  const [status, setStatus] = useState(3);
  const [loader, setLoader] = useState(-1);
  const [loader2, setLoader2] = useState(-1);
  const [loader3, setLoader3] = useState(-1);
  const [userId, setUserId] = useState("");
  const [driverBalance, setDriverBalance] = useState("");
  const [amount, setAmount] = useState("");
  const [driverName, setDriverName] = useState("");
  const [requestId, setRequestId] = useState("");
  const [vehicleOpen, setVehicleOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [driverOpen, setDriverOpen] = useState(false);
  const [driverSearch, setDriverSearch] = useState(false);
  const driverList = useSelector(
    (state) => state?.driverlist?.allDrivers?.divers?.rows
  );
  const driverCount = useSelector(
    (state) => state?.driverlist?.allDrivers?.divers?.count
  );
  const { advancedVehicleList, advancedVehicleListCount } = useSelector(
    (state) => state?.fleet
  );
  const [selectedVehicle, setSelectedVehicle] = useState("");
  const [selectedDriver, setSelectedDriver] = useState("");
  const [offset, setOffset] = useState(0);

  



  const cardRequest = useSelector((state) => state?.cardWallet?.cardRequest);
  console.log("cardRequestcardRequestcardRequest", loader, loader2, loader3);
  const [paymentRequestList, setPaymentRequestList] = useState([
    {
      amount: 1,
    },
    {
      amount: 1,
    },
  ]);
  const [refreshing, setRefreshing] = useState(false);
  const [open, setOpen] = useState(false);
  const [imageOpen, setImageOpen] = useState(false);
  const [images, setImages] = useState("");
  

  const imageCloseModal = () => {
    setImageOpen(false);
  };

  const setImageToggleModal = () => {
    setImageOpen(!imageOpen);
  };

  const toggleModal = () => {
    setOpen(!open);
  };

  const navigate = useNavigate()
  const onRefresh = () => {
    setRefreshing(true);
    // Perform refresh action here
    // Example: fetchPaymentRequestData();
    setRefreshing(false);
  };

  const renderFooter = () => {
    // Implement your ListFooterComponent logic here
    return null;
  };
  const handleClose = () => {
    setModal(false);
    setType("ALL");
    setStatus(3);
    setSelectedVehicle("");
    setSelectedDriver("");
    setOffset(0);
  };
  const handleLoader = (item) => {
    setLoader(item);
  };
  const handleLoader2 = (item) => {
    setLoader2(item);
  };
  const handleLoader3 = (item) => {
    setLoader3(item);
  };

  useEffect(() => {
    console.log("payloadcustomeRequest",{
      type: type,
      status: status,
      isOwner: 1,
      offset: offset,
      fleetId: selectedVehicle,
      driverUserId: selectedDriver,
    })
    dispatch(
      getCustomRequest({
        type: type,
        status: status,
        isOwner: 1,
        offset: offset,
        fleetId: selectedVehicle,
        driverUserId: selectedDriver,
      })
    );
    setLoader(-1);
    setLoader2(-1);
    setLoader3(-1);
    return function cleanUp() {};
  }, [requestType, type,selectedVehicle,selectedDriver,offset]);

  
  
  useEffect(() => {
    if (modal)
      dispatch(
        getCustomRequest({
          type: "ALL",
          status: status,
          isOwner: 1,
        })
      );
    return function cleanUp() {};
  }, [modal]);
  useEffect(() => {
    dispatch(
      advancedVehicleListAction({
        offset: 0,
        search: search.trim(),
        limit: 10,
        minKyc: "",
        sortAs: "",
        sortBy: "",
        activeStatus: "1",
        assignedStatus: "3",
      })
    );
    // dispatch(
    //   getVehicleListAction({
    //     offset: "",
    //     search: search,
    //     minKyc: "",
    //     sortAs: "",
    //     sortBy: "",
    //     limit: 10,
    //   })
    // );
  }, [search]);

  useEffect(() => {
    dispatch(
      getDriverList({
        offset: "",
        search: driverSearch,
        minKyc: "",
        sortAs: "",
        sortBy: "",
        limit: 10,
      })
    );
  }, [driverSearch]);
  return (
    <div>
      <Modal
        isOpen={modal}
        onHide={handleClose}
        className=" modal-dialog-centered model-width"
        toggle={toggle}
        aria-labelledby="myModalLabel2"
      >
        <ModalBody
          className="transactionModalBody"
          //   style={{ marginTop: "25px" }}
          //   style={{borderRadius : "10px"}}
          // style={{height : "75vh"}}
        >
          <div>
            <div className="closeBtnWithBackground" onClick={handleClose}>
              <SvgImage
                classname="close-btn-text"
                style={{ width: "10%", height: "10%" }}
                name="crossBtnWIthBackground"
                width="20%"
                height="20%"
              />
            </div>
            <div
              style={{ marginTop: " 10px", marginBottom: "10px" }}
              className="row"
              //   className="PGCollectionBox"
            >
              <div className="showroomText col-12">Requests</div>
            </div>
          </div>

          <div className="row box3 pt-0 justify-content-between">
            <div className="col-12 col-md-10">
              <button
                className={`Medium heading3 ${
                  type == "ALL" ? "greenButtonMini" : "greenOutlineButtonMini"
                } rounded-pill`}
                style={{ paddingLeft: "1rem", paddingRight: "1rem" }}
                onClick={(e) => {
                  setType("ALL");
                }}
              >
                All
              </button>
              <button
                className={`Medium heading3 ${
                  type == "UPIREQ"
                    ? "greenButtonMini"
                    : "greenOutlineButtonMini"
                } rounded-pill ms-3`}
                style={{ paddingLeft: "1rem", paddingRight: "1rem" }}
                onClick={(e) => {
                  setType("UPIREQ");
                  // setOffset(0);
                }}
              >
                UPI
              </button>
              <button
                className={`Medium heading3 ${
                  type == "CARDRECARGEREQ"
                    ? "greenButtonMini"
                    : "greenOutlineButtonMini"
                } rounded-pill ms-3`}
                style={{ paddingLeft: "1rem", paddingRight: "1rem" }}
                onClick={(e) => {
                  setType("CARDRECARGEREQ");
                  // setOffset(0);
                }}
              >
                CARD
              </button>
              <button
                className={`Medium heading3 ${
                  type == "OMCREQ"
                    ? "greenButtonMini"
                    : "greenOutlineButtonMini"
                } rounded-pill ms-3`}
                style={{ paddingLeft: "1rem", paddingRight: "1rem" }}
                onClick={(e) => {
                  setType("OMCREQ");
                  // setOffset(2);
                }}
              >
                FUEL
              </button>
              <button
                className={`Medium heading3 ${
                  type == "TRIPREQ"
                    ? "greenButtonMini"
                    : "greenOutlineButtonMini"
                } rounded-pill ms-3`}
                style={{ paddingLeft: "1rem", paddingRight: "1rem" }}
                onClick={(e) => {
                  setType("TRIPREQ");
                  // setOffset(3);
                }}
              >
                TRIP
              </button>

              <button
                className={`col-2`}
                style={{
                  paddingLeft: "1rem",
                  paddingRight: "1rem",
                  border: "0px",
                  background: "white",
                }}
                // onClick={(e) => {
                //   setType("TRIPREQ");
                //   // setOffset(3);
                // }}
              >
                <select
                  name="Status"
                  class="form-select Medium heading3 greenOutlineButtonMini rounded-pill ms-3"
                  aria-label="Default select example"
                  style={{ paddingTop: "2px", width: "auto" }}
                  onChange={(e) => {
                    console.log("selected val", e.target.value);
                    setStatus(e.target.value);
                    dispatch(
                      getCustomRequest({
                        type: type,
                        status: e.target.value,
                        isOwner: 1,
                      })
                    );
                  }}
                >
                  <option value="3">All</option>
                  <option value="0">Pending</option>
                  <option value="1">Accepted</option>
                  <option value="2">Rejected</option>
                  <option value="4">Auto-Acceptable</option>
                </select>
              </button>
            </div>
          </div>

          <div className="col-12 row" style={{}}>
            <div
              className="col-6"
              style={
                {
                  // width:'500px'
                }
              }
            >
              <Formik
                enableReinitialize
                initialValues={{
                  mode: "default",
                  fieldVal: "",
                  vehicleRN: "",
                  fleetIDVal: "",
                }}
                // validationSchema={validationSchema}
                onSubmit={(values, actions) => {}}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  setFieldValue,
                  isSubmitting,
                  /* and other goodies */
                }) => (
                  <Form onSubmit={handleSubmit} style={{ height: "100%" }}>
                    <FormGroup className="padding24 padding0B">
                      <div
                        className="searchBox"
                        onClick={() => {
                          setVehicleOpen(true);
                        }}
                        style={{
                          width: "250px",
                        }}
                      >
                        <input
                          className="searchBar-input"
                          type="text"
                          id="vehicleRN"
                          name="vehicleRN"
                          touched={touched.vehicleRN}
                          errors={errors.vehicleRN}
                          onBlur={handleBlur("vehicleRN")}
                          style={{ width: "80%" }}
                          onChange={(event) => {
                            console.log("onchangeselectVehicle", event.target.value,event.target.value.length);
                            if(event.target.value.length==0){
                              setOffset(0);
                              setSelectedVehicle("");
                              
                            }
                            
                            setSearch(event.target.value);
                            // setSelectedVehicle(event.target.value);
                            setFieldValue(
                              "vehicleRN",
                              event.target.value,
                              true
                            );
                          }}
                          value={values.vehicleRN}
                          autoFocus
                          placeholder="vehicle no."
                        />
                      </div>
                      <div style={{ position: "relative" }}>
                        {vehicleOpen ? (
                          <div className="driverSearchContainer containerShadow">
                            <div
                              style={{
                                position: "absolute",
                                top: "0.3rem",
                                right: "0.3rem",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                setVehicleOpen(false);
                              }}
                            >
                              <SvgImage name="CloseButtonLogo" />
                            </div>
                            {advancedVehicleList?.map((item, i) => {
                              return (
                                <>
                                  {item?.Fastag !== null ? (
                                    <div
                                      key={i}
                                      className="flexStyling padding8 "
                                      onClick={(event) => {
                                        console.log(
                                          "------->>>>>",
                                          item?.regNumber,
                                          item?.fleetId
                                        );
                                        setOffset(0);
                                        setSelectedVehicle(item?.fleetId);
                             
                                        setVehicleOpen(false);
                                        // setUserId(event.target.value);
                                        setFieldValue(
                                          "vehicleRN",
                                          item?.regNumber,
                                          true
                                        );
                                        setFieldValue(
                                          "fleetIDVal",
                                          item?.fleetId,
                                          true
                                        );
                                      }}
                                    >
                                      <input
                                        type="radio"
                                        name="vehicleRN"
                                        value={item?.fleetId}
                                        id={item?.fleetId}
                                      />
                                      <div
                                        className="padding16L"
                                        value={item?.fleetId}
                                      >
                                        {item?.regNumber}
                                      </div>
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                </>
                              );
                            })}
                            {advancedVehicleListCount == 0 ? (
                              <div className="heading3 semiBold padding16 padding24B">
                                No Vehicle Available
                              </div>
                            ) : (
                              <></>
                            )}
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                      {/* <div className="heading4 Regular"
                              style={{ margin: "7px 0 0px 0", color: "red" }}>
                                  {errors.fleetIDVal && touched.fleetIDVal ? (
                                      <div>*{errors.fleetIDVal}</div>
                                  ) : null}
                          </div> */}
                    </FormGroup>
                  </Form>
                )}
              </Formik>
            </div>

            <div
              className="col-6"
              style={
                {
                  // width:'500px'
                }
              }
            >
              <Formik
                enableReinitialize
                initialValues={{
                  // startDate: "",
                  // endDate: "",
                  mode: "default",
                  fieldVal: "",
                  driverName: "",
                  userIDVal: "",
                }}
                // validationSchema={validationSchema}
                onSubmit={(values, actions) => {}}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  setFieldValue,
                  isSubmitting,
                  /* and other goodies */
                }) => (
                  <Form onSubmit={handleSubmit} style={{ height: "100%" }}>
                    <FormGroup className="padding24 padding0B">
                      <div
                        className="searchBox"
                        onClick={() => {
                          setDriverOpen(true);
                        }}
                        style={{
                          width: "250px",
                          marginLeft: "-160px",
                        }}
                      >
                        <input
                          className="searchBar-input"
                          type="text"
                          id="driverName"
                          name="driverName"
                          touched={touched.driverName}
                          errors={errors.driverName}
                          onBlur={handleBlur("driverName")}
                          style={{ width: "80%" }}
                          placeholder="Enter driver's name"
                          onChange={(event) => {
                            setDriverSearch(event.target.value);
                            if(event.target.value.length==0){
                              setOffset(0);
                              setSelectedDriver("");
                            }
                            
                            setFieldValue(
                              "driverName",
                              event.target.value,
                              true
                            );
                          }}
                          value={values.driverName}
                          autoFocus
                        />
                      </div>
                      <div style={{ position: "relative" }}>
                        {driverOpen ? (
                          <div
                            className="driverSearchContainer containerShadow"
                            style={{
                              marginLeft: "-160px",
                            }}
                          >
                            <div
                              style={{
                                position: "absolute",
                                top: "0.3rem",
                                right: "0.3rem",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                setDriverOpen(false);
                              }}
                            >
                              <SvgImage name="CloseButtonLogo" />
                            </div>
                            {driverList?.map((item, i) => {
                              return (
                                <div
                                  key={i}
                                  className="flexStyling padding8 "
                                  onClick={(event) => {
                                    console.log(
                                      "setOpensetOpensetOpen",
                                      event,
                                      item?.User?.fullName,
                                      event.target.value,
                                      item
                                    );
                                    setDriverOpen(false);
                                    // setUserId(event.target.value);
                                    setOffset(0);
                                    setSelectedDriver(item?.User?.userId);
                                    
                                    setFieldValue(
                                      "driverName",
                                      item?.User?.fullName,
                                      true
                                    );
                                    setFieldValue(
                                      "userIDVal",
                                      item?.User?.userId,
                                      true
                                    );
                                  }}
                                >
                                  <input
                                    type="radio"
                                    name="drivername"
                                    value={item?.User?.userId}
                                    id={item?.User?.userId}
                                  />
                                  <div className="padding16L">
                                    {item?.User?.fullName.length > 35
                                      ? item?.User?.fullName.split(0, 35) +
                                        "..."
                                      : item?.User?.fullName}
                                  </div>
                                </div>
                              );
                            })}
                            {driverCount == 0 ? (
                              <div className="heading3 semiBold padding16 padding24B">
                                No Driver Available
                              </div>
                            ) : (
                              <></>
                            )}
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                      <div
                        className="heading4 Regular"
                        style={{ margin: "7px 0 0px 0", color: "red" }}
                      >
                        {errors.userIDVal && touched.userIDVal ? (
                          <div>*{errors.userIDVal}</div>
                        ) : null}
                      </div>
                    </FormGroup>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
         

          {
            <div className="row">
              {customRequest?.rows?.map((item, index) => {
                console.log("hvhvhvhvhvhvhv", item);
                console.log("nsjbjzbjzxbxjzb", typeof item?.body, item?.body);
                let listObj = item?.body;
                let parsedBody =
                  typeof item.body == "object"
                    ? item.body
                    : JSON.parse(item.body);
                console.log(
                  "parsedBodyparsedBody",
                  typeof parsedBody,
                  parsedBody,
                  parsedBody?.lat,
                  parsedBody?.long
                );

                console.log("parsedBodypppppp", parsedBody);

                return (
                  <div className="col-4" style={{ padding: "18px" }}>
                    <div className="miniCard" style={{ height: "100%" }}>
                      <div style={{ height: "85%" }}>
                        <div className="row ">
                          <div className="col-6 d-flex flex-column">
                          <div className=" FontNR14"> {" Driver Name: "}</div>
                          <div className="FontNS14">
                            {" "}
                            {parsedBody?.tripData
                              ? parsedBody?.tripData?.User?.fullName ||
                                parsedBody?.fullName
                              : item?.fullName}
                          </div>
                          </div>
                          {
                            item?.id ? <div className="col-6 d-flex flex-column">
                            <div className=" FontNR14"> {"Vehicle Number"}</div>
                            <div className="FontNS14">
                              {" "}
                              {item?.id}
                            </div>
                            </div> : <></>
                          }


                        </div>
                        <div className="row">
                          <div className=" FontNR14"> {" Amount: "}</div>
                          <div className=" FontNS14"> {"₹" + item?.amount}</div>
                        </div>
                        <div className="row">
                          <div className=" FontNR14"> {" Requested: "}</div>
                          <div className=" FontNS14">{item?.createdAt}</div>
                        </div>
                        <div className="row">
                          <div className=" FontNR14"> {"Purpose: "}</div>
                          <div className=" FontNS14">
                            {item?.typeOftransaction == "TRIPREQ"
                              ? (parsedBody?.tripData?.Fleet?.regNumber || "") +
                                  " " || ""
                              : ""}
                            {item?.typeOftransaction
                              ? item?.typeOftransaction?.substring(
                                  0,
                                  item?.typeOftransaction?.length - 3
                                )
                              : ""}
                            {item?.typeOftransaction == "TRIPREQ"
                              ? " " + parsedBody?.tripKey || ""
                              : ""}
                          </div>
                        </div>
                        {((parsedBody?.lat && parsedBody?.long) ||
                          parsedBody?.tripData?.sourceAddress?.cityName) && (
                          <div className="row">
                            <div className=" FontNR14"> {"Location"}</div>
                            <div className=" FontNS14">
                              <div
                                style={{
                                  textDecoration: "underline",
                                  color: "#ED752E",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  console.log("clkickejbjbb");
                                  if (parsedBody?.lat && parsedBody?.long) {
                                    window.open(
                                      `https://www.google.com/maps/search/${parsedBody?.lat},${parsedBody?.long}`
                                    );
                                  } else {
                                    window.open(
                                      `https://www.google.com/maps/dir/${parsedBody?.tripData?.sourceAddress?.cityName}/${parsedBody?.tripData?.destAddress?.cityName}`
                                    );
                                  }
                                }}
                              >
                                {parsedBody?.lat && parsedBody?.long
                                  ? "Click Here"
                                  : parsedBody?.tripData?.sourceAddress
                                      ?.cityName +
                                    " - " +
                                    parsedBody?.tripData?.destAddress?.cityName}
                              </div>
                            </div>
                          </div>
                        )}
                        <div className="row">
                          <div className=" FontNR14">
                            {" "}
                            {item?.typeOftransaction == "TRIPREQ"
                              ? "Trip:"
                              : "Image:"}
                          </div>
                          <div
                            className=" FontNS14"
                            style={{
                              textDecoration: "underline",
                              color: "#ED752E",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              if (
                                item?.typeOftransaction == "TRIPREQ" &&
                                item?.trip?.tripNo
                              ) {
                                console.log("jierj0ijfer",window.location)
                                if(window.location?.pathname?.includes("/trips/")){
                                  storeDataToAsyncStorage("row", item?.trip);
                                  navigate(`/trips/${item?.trip?.tripId}`);
                                  window.location.reload()
                                }
                                else{
                                  storeDataToAsyncStorage("row", item?.trip);
                                  navigate(`/trips/${item?.trip?.tripId}`);
                                }
                                handleClose()
                              }
                            }}
                          >
                            {item?.typeOftransaction == "TRIPREQ" ? (
                              item?.trip?.tripNo
                            ) : item?.data ? (
                              <div
                                style={{
                                  textDecoration: "underline",
                                  color: "#ED752E",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  console.log("shjskjd", item?.allImage);

                                  setImages(item?.allImage);
                                  setImageToggleModal();
                                }}
                              >
                                Click Here
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                      <div
                        className="d-flex justify-content-between"
                        style={{ height: "10%", marginTop: "5%" }}
                      >
                        {item?.status == 1 ||
                        item?.status == 2 ||
                        item?.status == 3 ? (
                          <>
                            <div>
                              {" "}
                              <button
                                // disabled={true}
                                onClick={() => {
                                  console.log("clicked deleted");
                                  handleLoader(index);
                                  dispatch(
                                    deleteCustomRequest(
                                      {
                                        requestId: item?.requestId,
                                      },
                                      (res) => {
                                        console.log(
                                          "requestId:item?.requestId",
                                          res
                                        );
                                        handleLoader(-1);
                                        dispatch(
                                          getCustomRequest({
                                            type: type,
                                            status: status,
                                            isOwner: 1,
                                          })
                                        );
                                      }
                                    )
                                  );
                                }}
                                style={{
                                  backgroundColor: "white",
                                  borderRadius: "5px",
                                  color: "red",
                                  // marginTop: "10px",
                                }}
                              >
                                Delete
                              </button>
                            </div>
                            {/* <div className="col-3"></div> */}
                          </>
                        ) : (
                          <div
                            style={{
                              flex: 2,
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <div className="">
                              <button
                                style={{
                                  backgroundColor:
                                    loader2 == index || item?.status == 4
                                      ? null
                                      : "#485b7c",
                                  borderRadius: "5px",
                                  color:
                                    loader2 == index || item?.status == 4
                                      ? "black"
                                      : "white",
                                  // marginTop: "10px",
                                }}
                                disabled={
                                  loader2 == index || item?.status == 4
                                    ? true
                                    : false
                                }
                                onClick={() => {
                                  console.log("clicked Accept", item?.Card);
                                  setUserId(item?.Card?.userId);
                                  setDriverBalance(item?.Card?.balance);
                                  setDriverName(item?.driverName);
                                  setAmount(item?.amount);
                                  setRequestId(item?.requestId);
                                  // setOpen(true);
                                  handleLoader2(index);
                                  // setLoader2(true)
                                  // setLoader3(false)
                                  dispatch(
                                    updateCustomRequest(
                                      {
                                        requestId: item?.requestId,
                                        status: 1,
                                      },
                                      (res) => {
                                        console.log(
                                          "requestId:item?.requestId",
                                          res
                                        );
                                        handleLoader2(-1);
                                        dispatch(
                                          getCustomRequest({
                                            type: type,
                                            status: status,
                                            isOwner: 1,
                                          })
                                        );
                                      }
                                    )
                                  );
                                }}
                              >
                                {loader2 == index ? "Wait" : "Accept"}
                              </button>
                            </div>
                            <div className="">
                              <button
                                style={{
                                  backgroundColor:
                                    loader3 == index ? null : "#d54545",
                                  // marginLeft: "10px",
                                  borderRadius: "5px",
                                  color: loader3 == index ? "black" : "white",
                                  // marginTop: "10px",
                                }}
                                disabled={loader3 == index ? true : false}
                                onClick={() => {
                                  console.log("clicked Reject");
                                  handleLoader3(index);
                                  dispatch(
                                    updateCustomRequest(
                                      {
                                        requestId: item?.requestId,
                                        status: 2,
                                      },
                                      (res) => {
                                        console.log(
                                          "requestId:item?.requestId",
                                          res
                                        );
                                        handleLoader3(-1);
                                        dispatch(
                                          getCustomRequest({
                                            type: type,
                                            status: status,
                                            isOwner: 1,
                                          })
                                        );
                                      }
                                    )
                                  );
                                }}
                              >
                                {loader3 == index ? "Wait" : "Reject"}
                              </button>
                            </div>
                          </div>
                        )}
                        <div
                          // className="col-4"
                          style={{
                            // padding: "12px 0px 0px",
                            margin: "0px 0 0 46px",
                            flex: 1,
                          }}
                        >
                          <div
                            style={{
                              background:
                                item?.status == "0"
                                  ? "#e2bc3c"
                                  : item?.status == "1" || item?.status == "4"
                                  ? "green"
                                  : "red",
                              padding: "0 0 0 10px",
                            }}
                            className={"tabSide"}
                          >
                            {item?.status == "0"
                              ? "Pending"
                              : item?.status == "1"
                              ? "Accepted"
                              : item?.status == "4"
                              ? "AUTO"
                              : "Rejected"}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
               <div className="nextRow ">
            <div className="nextRowCont ">
              <button
                className="PrevButton"
                onClick={() => {
                  console.log("offsetttP",offset)

                  let toffset = offset - 12;
                  if(toffset>0){
                  setOffset(offset - 12);
                }else{
                  setOffset(0);
                }
                }}
                style={{ opacity: offset > 0 ? "1" : "0.5" }}
              >
                <SvgImage name="PrevArrow" heigth="12px" width="12px" />
              </button>
              {/* add loader to button */}

              <button
                className="nextButton"
                onClick={() => {
                  console.log("offsettt",offset)
                  setOffset(offset + 12);
                }}
                style={{
                  opacity:
                  customReqCount - offset > 12 ? "1" : "0.5",
                }}


              >
                <SvgImage name="NextArrow" heigth="12px" width="12px" />
              </button>
            </div>
          </div>
            </div>
          }
        </ModalBody>
      </Modal>

      <ManageDriverAddBalance
        open={open}
        toggleModal={toggleModal}
        handleClose={handleClose}
        name="Add Balance"
        userId={userId}
        driverBal={driverBalance}
        cardType={1}
        driverName={driverName}
        offset={0}
        search={0}
        amount={amount}
        apiCall={true}
        requestId={requestId}
      />
      <AllImagePopup
        open={imageOpen}
        onHide={imageCloseModal}
        toggleModal={setImageToggleModal}
        handleClose={imageCloseModal}
        image={images || []}
        text={"All Images"}
      />
    </div>
  );
}

export default RequestsV2;
